import { getBooking } from "../../../app/api/getBooking";
import { getTravelAccounts } from "../../../app/api/getTravelAccounts";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IPassBooking } from "../../../Orchestrator/Types/Types/BookingTypes";

export class GetPassBookingObjectAction extends BaseAction<IPassBooking | null, { bookingId: string }> {
  override async run(): Promise<IPassBooking | null> {
    let result: IPassBooking | null = null;
    const { bookingId } = this.params!;

    if (!bookingId) { return null; }

    try {
      const bookingDetailResponse = await getBooking(bookingId, false);
      if (bookingDetailResponse.status === "ok" && bookingDetailResponse.answer) {
        const bookingDetail = bookingDetailResponse.answer;

        const passengers = bookingDetail.booking?.passengers || [];
        let cardIssuer: string | undefined;
        let cardNumber: string | undefined;

        for (const passenger of passengers) {
          const cards = (passenger as any).cards || [];
          for (const card of cards) {
            if (card?.type === "TRAVEL_PASS" && card.number) {
              cardIssuer = card.issuer || cardIssuer;
              cardNumber = card.number;
              break;
            }
          }
          if (cardNumber) break;
        }

        let issuer: string | undefined;
        let travelAccount: string | undefined;

        if (cardNumber) {
          issuer = cardIssuer || bookingDetail.booking.fulfillments?.[0]?.issuer;
          travelAccount = cardNumber;
          if (!issuer) { }
        } else {
          if (!bookingDetail.booking.fulfillments || bookingDetail.booking.fulfillments.length === 0) {
            return null;
          }

          const fulfillment = bookingDetail.booking.fulfillments[0];
          if (!fulfillment.issuer || !fulfillment.controlNumber) {
            return null;
          }

          issuer = fulfillment.issuer;
          travelAccount = fulfillment.controlNumber;
        }

        if (!issuer || !travelAccount) {
          return null;
        }

        const travelAccountResponse = await getTravelAccounts({
          issuer: issuer,
          travelAccount: travelAccount
        }, false)

        if (travelAccountResponse.status === "ok" && travelAccountResponse.answer) {
          const travelAccountDetail = travelAccountResponse.answer;
          result = {
            booking: bookingDetail,
            travelAccount: travelAccountDetail
          }
        }
      }
    } catch (error) {
      console.error("Error fetching pass booking:", error);
    } finally {
      return result
    }
  }
}

export const getPassBookingObjectAction = new GetPassBookingObjectAction(); 
